import { getCookie, setCookie } from '@utils/cookie'
const state = {
  /* 侧边栏是否展开 */
  sidebar: {
    opened: getCookie('sidebarStatus') ? !!+getCookie('sidebarStatus') : true
  },
  /* 内容的属性 */
  container: {
    width: getCookie('app_width') || 1730, // 基于1920 * 1080
    height: getCookie('app_height') || 837 // 基于1920 * 1080
  },
  language: localStorage.getItem('language') || 'zh' // 网站语言
}
const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    if (state.sidebar.opened) {
      setCookie('sidebarStatus', 1)
    } else {
      setCookie('sidebarStatus', 0)
    }
  },
  SET_CONTAINER: (state, payload) => {
    state.container.width = payload.width
    state.container.height = payload.height
    setCookie('app_width', payload.width)
    setCookie('app_height', payload.height)
  },
  CHANGE_LANG: state => {
    var lang = localStorage.getItem('language')
    state.language = lang
  }
}
const actions = {
  toggleSideBar ({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  setContainer ({ commit }, payload) {
    commit('SET_CONTAINER', payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
